import { createAction, props } from '@ngrx/store';

export const getRootCatalog = createAction('[Data Product] Get Root Catalog');
export const getVariableCount = createAction('[Data Product] Get Variable Count');
export const selectDataProduct = createAction('[Data Product] Select Data Product', props<{ catalogId: string; dataProductId: string }>());
export const initialized = createAction('[Data Product] Initialized');
